/* eslint-disable */
export default {
  contactDetails: 'Contact details',
  loadingContact: 'Loading contact...',
  contactNotFound: 'Contact not found.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
